// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  height: 100%;
}

.hands {
  width: 100%;
  height: auto;
}

.instruction {
  text-align: center;
  padding: 0 16px;
}

.buttons-row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/scan-chip/pass.fp.verify.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;AACJ","sourcesContent":[".container {\n    width: 100%;\n    height: 100%;\n}\n\n.hands {\n    width: 100%;\n    height: auto;\n}\n\n.instruction {\n    text-align: center;\n    padding: 0 16px;\n}\n\n.buttons-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
